import { render, staticRenderFns } from "./current-task-detail.vue?vue&type=template&id=1a558cfc&scoped=true&"
import script from "./current-task-detail.vue?vue&type=script&lang=js&"
export * from "./current-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./current-task-detail.vue?vue&type=style&index=0&id=1a558cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a558cfc",
  null
  
)

export default component.exports